"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var constants_1 = require("containers/App/constants");
var SidebarGroup_1 = __importDefault(require("../SidebarGroup"));
var CompanySettings = function (_a) {
    var isLocked = _a.isLocked;
    return ((0, jsx_runtime_1.jsx)(SidebarGroup_1.default, { categoryLabel: "Company settings", menuItems: constants_1.MENU_COMPANY_SETTINGS, isLocked: isLocked }));
};
exports.default = CompanySettings;
